import { useGetConfigQuery } from '@common/config';
import { useConsent } from '@common/ui';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export function MatomoProvider() {
  const { data: config, isLoading } = useGetConfigQuery();
  const { finalityConsent } = useConsent();

  useEffect(() => {
    if (!finalityConsent?.analytics) return;
    if (!config) return;
    if (!config.MATOMO_INSCRIPTION_URL?.trim() || config.MATOMO_INSCRIPTION_URL === 'MATOMO_INSCRIPTION_URL_VALEUR') return;
    if (document.getElementById('matomo_analytics')) return;

    window._mtm = window._mtm || [];
    window._mtm.push({
      'mtm.startTime': Date.now(),
      event: 'mtm.Start',
    });

    const script = document.createElement('script');
    script.id = 'matomo_analytics';
    script.async = true;
    script.src = config['MATOMO_INSCRIPTION_URL'];

    document.head.appendChild(script);

  }, [finalityConsent?.analytics, isLoading]);

  return <Outlet />;
}